import SettingsContent from '../Wrapper';
import Index from './Index.vue';
import { frontendURL } from '../../../../helper/URLHelper';
//chatlyn
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/sms'),
      component: SettingsContent,
      props: {
        headerTitle: 'CHATLYN_SMS_SENDING.TITLE',
        icon: 'chatlyn-sms',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'settings_sms_index',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
